import fetch from '../../rest/cards-assign-to-list';

export default fetch;
